var map = {
	"./akademik-takvim.subPage.js": 9152,
	"./binamiz.subPage.js": 85279,
	"./calisma-saatleri.subPage.js": 94593,
	"./duyurular.subPage.js": 60698,
	"./e-brosur.subPage.js": 59079,
	"./egitim-anlayisimiz.subPage.js": 28270,
	"./hakkimizda.subPage.js": 70683,
	"./tatil-uygulamasi.subPage.js": 38003,
	"./veli-gorusleri.subPage.js": 67213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35010;